import React from 'react';

import Modal from './Modal';
import styles from './VideoModal.scss';

const VideoModal = ({ src, open, onClose }) => {
    if (!open) {
        return null;
    }

    return (
        <Modal
            onClose={onClose}
            styles={{
                padding: 0,
                minHeight: 0,
                width: 700,
                height: (700 / 16) * 9,
                maxWidth: 700,
            }}
            width={400}
            height={(400 / 16) * 9}
        >
            <p className={styles.intro}>
                Er zijn best wel veel kinderen met een mama of papa die drinkt
                of drugs gebruikt. Die situatie is voor iedereen anders, maar
                nooit eenvoudig. Dit filmpje toont hoe het voor Femke is.
            </p>
            <div className="embed-responsive embed-responsive-16by9">
                <iframe
                    className="embed-responsive-item"
                    id="ytplayer"
                    title="getuigenis"
                    type="text/html"
                    width="100%"
                    height="100%"
                    src={src}
                    frameBorder="0"
                    allowFullScreen
                />
            </div>
        </Modal>
    );
};

export default VideoModal;



// WEBPACK FOOTER //
// ./src/components/VideoModal.js